import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  separatorContainer: {
    textAlign: 'center',
    padding: '40px 0',
    position: 'relative'
  },
  separatorLine: {
    '&:after': {
      content: "''",
      position: 'absolute',
      height: '1px',
      width: '100%',
      borderTop: "1px dashed ".concat(palette.shades[400]),
      top: '53px',
      left: '0',
      right: '0'
    }
  },
  separatorText: {
    color: palette.shades[700],
    padding: '0 10px',
    display: 'inline-block',
    backgroundColor: palette.shades[200],
    position: 'relative',
    zIndex: '10'
  },
  separatorDot: {
    padding: '0 4px'
  }
});
export default useStyles;